import { z } from "zod";

export const upsertBundleSchema = z.object({
  id: z.string().optional(),
  slug: z.string().trim().min(2).max(60),
  name: z.string().trim().min(2),
  description: z.string().trim().optional(),
  imageUrl: z.string().url().nullable().optional(),
  bundlePrice: z.number().int().positive(),
  isActive: z.boolean().optional(),
  sortOrder: z.number().int().optional(),
  items: z
    .array(
      z.object({
        productId: z.string().min(1),
        quantity: z.number().int().positive()
      })
    )
    .min(1, "A bundle needs at least one product")
});
export type UpsertBundleInput = z.infer<typeof upsertBundleSchema>;
